import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { getUploadParams } from './service.js';
import dayjs from 'dayjs';

const OSSUpload = ({
  onChange,
  value,
  buttonText,
  folderId,
  bucket = 'savvyuni-intl-erp',
  addTimestamp,
  ...rest
}) => {
  const [ossData, setOssData] = useState();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (!value) {
      setFileList([]);
    } else {
      if (Array.isArray(value)) {
        setFileList(value);
      } else {
        setFileList([value]);
      }
    }
  }, [value]);

  const handleBeforeUpload = async (file) => {
    if (addTimestamp) {
      file.url = `${dayjs().format('YYYYMMDDHHmmss')}_${file.name}`;
    }
    return file;
  };

  const getOSSAuth = async (file) => {
    if (!ossData || new Date().getTime() > ossData.expire) {
      const res = await getUploadParams({
        folderId,
      });
      setOssData(res);
      return {
        key: `${res.dir}/${addTimestamp && file.url ? file.url : file.name}`,
        OSSAccessKeyId: res.accessId,
        policy: res.policy,
        Signature: res.signature,
      };
    } else {
      return {
        key: `${ossData.dir}/${addTimestamp && file.url ? file.url : file.name}`,
        OSSAccessKeyId: ossData.accessId,
        policy: ossData.policy,
        Signature: ossData.signature,
      };
    }
  };

  const onUploadChange = ({ file }) => {
    let newFileList = [];
    if (file.status === 'removed') {
      newFileList = [...fileList.filter((f) => f.uid !== file.uid)];
    } else {
      if (fileList.some((f) => f.uid === file.uid)) {
        newFileList = [
          ...fileList.map((f) => {
            if (f.uid === file.uid) {
              const newFile = {
                ...f,
                ...file,
              };
              if (file.status === 'done') {
                newFile.bucket = bucket;
                newFile.key = `${ossData.dir}/${addTimestamp && file.url ? file.url : file.name}`;
              }
              return newFile;
            }
            return f;
          }),
        ];
      } else {
        newFileList = [...fileList, file];
      }
    }
    if (rest.maxCount && newFileList.length > rest.maxCount) {
      newFileList = newFileList.splice(newFileList.length - rest.maxCount);
    }
    setFileList(newFileList);
    if (onChange && typeof onChange === 'function') {
      if (rest.maxCount === 1) {
        onChange(newFileList[0]);
      } else {
        onChange(newFileList);
      }
    }
  };

  return (
    <Upload
      action={`https://${bucket}.oss-accelerate.aliyuncs.com`}
      data={getOSSAuth}
      fileList={fileList}
      onChange={onUploadChange}
      beforeUpload={handleBeforeUpload}
      {...rest}
    >
      <Button icon={<UploadOutlined />} {...rest}>
        {buttonText || '点击上传'}
      </Button>
    </Upload>
  );
};

export default OSSUpload;
